// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"fd9bd042","160":"57ba5601","239":"bc6f35cc","453":"8791688f","561":"52a9357a"}[chunkId] + ".chunk.js";
};